import r from "react";
import a from "react-slick";
import i from "classnames";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import l from "./slider.module.scss.js";
const N = r.forwardRef((t, m) => {
  const {
    settings: e,
    children: o
  } = t;
  return /* @__PURE__ */ r.createElement("div", { "data-testid": "slider" }, /* @__PURE__ */ r.createElement(
    a,
    {
      ...e,
      ref: m,
      className: i(e == null ? void 0 : e.className, l.slider)
    },
    o
  ));
});
export {
  N as Slider
};
//# sourceMappingURL=Slider.js.map
